module.exports = __webpack_public_path__ + "static/media/maintenance.fd8ea419.svg";